export const ObjectNames = {
    // Handrail Tubes
    handrailWooden: 'WOODEN_HANDRAIL',
    handrailSquareTube: 'METAL_TUBE_SQUARE',
    handrailRoundTube: 'METAL_TUBE_ROUND',
    // Handrail Joiners
    joinerSquareSatin: 'HR-SS-2004',
    joinerSquareMirror: 'HR-2004',
    joinerRound: 'HR-2004E',
    // Wire Balustrade Systems - Rig Fork Components
    wireRigForkTimberHook: 'RIG-FORK_SYSTEM_SADDLES_TIMBER_HOOK',
    wireRigForkWire: 'RIG-FORK_SYSTEM_WIRE',
    wireRigForkScrewEye: 'RIG-FORK_SYSTEM_SCREW_EYE',
    wireRigForkNutRivet: 'RIG-FORK_SYSTEM_NUT_RIVET',
    wireRigForkMetalHook: 'RIG-FORK_SYSTEM_SADDLES_METAL_HOOK',
    // Wire Balustrade Systems - Insert Components
    wireInsertTimberScrew: 'INSERT_SYSTEM_TIMBER_SCREW',
    wireInsertWire: 'INSERT_SYSTEM_WIRE',
    wireInsertMetalRivet: 'INSERT_SYSTEM_METAL_RIVET',
    wireFlipLockInsert: 'FLIP-LOCK_SYSTEM_INSERT',
    // Wire Balustrade Systems - Stainless Steel Components
    wireStainlessSteelRotatable: 'SS-7813-001A_ROTATABLE',
    wireStainlessSteel: 'SS-7813-001A',
    // Round Handrail End Fittings
    roundEndElbow: 'HR-2002E',
    roundAdjustableCorner: 'RADJ01-001A',
    roundAdjustableCornerRotatable: 'RADJ01-001A_ROTATABLE',
    roundAdjustableStairCorner: 'RADJ9001-001A',
    roundAdjustableStairCornerRotatable: 'RADJ9001-001A_ROTATABLE',
    roundFreeEnd: 'HR-2019A',
    roundRadiusedEndCap: 'HR-2017A',
    roundDomedEndCap: 'HR-2018A',
    roundWallPlate: 'HR-2016A',
    roundOblongWallPlate: 'HR-2014A',
    // Square Handrail End Fittings
    squareElbow: 'HR-SS-2002',
    squareAdjustableCorner: 'SADJ01-001A',
    squareAdjustableCornerRotatable: 'SADJ01-001A_ROTATABLE',
    squareAdjustableStairCorner: 'SADJ9001-001A',
    squareAdjustableStairCornerRotatable: 'SADJ9001-001A_ROTATABLE',
    squareFreeEnd: 'HR-SS-2019',
    squareWallPlate: 'HR-SS-2016A',
    squareOblongWallPlate: 'HR-SS-2014A',
    // Posts
    postWooden: 'WOODEN_POST',
    postThinIntermediate: 'INT5010',
    postAluminium: 'ALP-PLAIN-50956',
    postStainlessSteelRound: 'SRP-PLAIN-50960',
    postStainlessSteelAngledRound: 'SRP-PLAIN-ANG-50960',
    // Post Tops - Aluminium
    aluminiumTopIntermediate: 'ALP-TOP-INT',
    aluminiumTopEnd: 'ALP-TOP-END',
    aluminiumTopCorner: 'ALP-TOP-CNR',
    aluminiumTopEndAngled: 'ALP-TOP-END-ANG',
    // Post Tops - Stainless Steel Flat
    stainlessSteelTopFlat4: 'PSF04-001P',
    stainlessSteelTopFlat1: 'PSF01-001P',
    stainlessSteelTopFlat3: 'PSF03-001P',
    stainlessSteelTopFlat2: 'PSF02-001P',
    stainlessSteelTopFlat7: 'PSF07-001P',
    stainlessSteelTopFlat6: 'PSF06-001P',
    stainlessSteelTopFlat5: 'PSF05-001P',
    // Post Tops - Stainless Steel Round
    stainlessSteelTopRound1: 'PSR01-001P',
    stainlessSteelTopRound2: 'PSR02-001P',
    stainlessSteelTopRound3: 'PSR03-001P',
    stainlessSteelTopRound4: 'PSR04-001P',
    stainlessSteelTopRound5: 'PSR05-001P',
    stainlessSteelTopRound6: 'PSR06-001P',
    stainlessSteelTopRound7: 'PSR07-001P',
    // Additional Posts
    postStainlessSteelRoundPlain: 'SSP-PLAIN-50960',
    postStainlessSteelAngledRoundPlain: 'SSP-PLAIN-ANG-50960',
    // Grommets and Hardware
    grommetLarge: 'GROM-L',
    grommetSmallBlack: 'GROM-S-BK',
    grommetSmallSatin: 'GROM-S-SR',
    grommetLargeBlack: 'GROM-L-BK',
    grommetLargeAngledBlack: 'GROM-LA-BK',
    grommetStairAngledBlack: 'GROM-SA-BK',
    grommetStairAngledSatin: 'GROM-SA-SR'
};
export const Objects = {
    // Handrail Tubes
    [ObjectNames.handrailWooden]: {
        fileUrl: '/models/main.glb'
    },
    [ObjectNames.handrailSquareTube]: {
        fileUrl: '/models/main.glb'
    },
    [ObjectNames.handrailRoundTube]: {
        fileUrl: '/models/main.glb'
    },
    // Handrail Joiners
    [ObjectNames.joinerSquareSatin]: {
        fileUrl: '/models/handrails-fitting-square.glb'
    },
    [ObjectNames.joinerSquareMirror]: {
        fileUrl: '/models/handrails-fitting-square.glb'
    },
    [ObjectNames.joinerRound]: {
        fileUrl: '/models/handrails-fitting-round.glb'
    },
    // Wire Balustrade Systems - Rig Fork Components
    [ObjectNames.wireRigForkTimberHook]: {
        fileUrl: '/models/rig-fork-components.glb',
        centerOffset: 6
    },
    [ObjectNames.wireRigForkWire]: {
        fileUrl: '/models/rig-fork-components.glb',
        scaleZero: 256 - 12,
        scaleOne: 10012 - 12
    },
    [ObjectNames.wireRigForkScrewEye]: {
        fileUrl: '/models/rig-fork-components.glb'
    },
    [ObjectNames.wireRigForkNutRivet]: {
        fileUrl: '/models/rig-fork-components.glb'
    },
    [ObjectNames.wireRigForkMetalHook]: {
        fileUrl: '/models/rig-fork-components.glb'
    },
    // Wire Balustrade Systems - Insert Components
    [ObjectNames.wireInsertTimberScrew]: {
        fileUrl: '/models/insert-components.glb'
    },
    [ObjectNames.wireInsertWire]: {
        fileUrl: '/models/insert-components.glb'
    },
    [ObjectNames.wireInsertMetalRivet]: {
        fileUrl: '/models/insert-components.glb'
    },
    [ObjectNames.wireFlipLockInsert]: {
        fileUrl: '/models/insert-components.glb'
    },
    // Wire Balustrade Systems - Stainless Steel Components
    [ObjectNames.wireStainlessSteelRotatable]: {
        fileUrl: '/models/stainless-steel-components.glb'
    },
    [ObjectNames.wireStainlessSteel]: {
        fileUrl: '/models/stainless-steel-components.glb'
    },
    // Round Handrail End Fittings
    [ObjectNames.roundEndElbow]: {
        fileUrl: '/models/handrails-fitting-round.glb'
    },
    [ObjectNames.roundAdjustableCorner]: {
        fileUrl: '/models/handrails-fitting-round.glb'
    },
    [ObjectNames.roundAdjustableCornerRotatable]: {
        fileUrl: '/models/handrails-fitting-round.glb'
    },
    [ObjectNames.roundAdjustableStairCorner]: {
        fileUrl: '/models/handrails-fitting-round.glb'
    },
    [ObjectNames.roundAdjustableStairCornerRotatable]: {
        fileUrl: '/models/handrails-fitting-round.glb'
    },
    [ObjectNames.roundFreeEnd]: {
        fileUrl: '/models/handrails-fitting-round.glb'
    },
    [ObjectNames.roundRadiusedEndCap]: {
        fileUrl: '/models/handrails-fitting-round.glb'
    },
    [ObjectNames.roundDomedEndCap]: {
        fileUrl: '/models/handrails-fitting-round.glb'
    },
    [ObjectNames.roundWallPlate]: {
        fileUrl: '/models/handrails-fitting-round.glb'
    },
    [ObjectNames.roundOblongWallPlate]: {
        fileUrl: '/models/handrails-fitting-round.glb'
    },
    // Square Handrail End Fittings
    [ObjectNames.squareElbow]: {
        fileUrl: '/models/handrails-fitting-square.glb'
    },
    [ObjectNames.squareAdjustableCorner]: {
        fileUrl: '/models/handrails-fitting-square.glb'
    },
    [ObjectNames.squareAdjustableCornerRotatable]: {
        fileUrl: '/models/handrails-fitting-square.glb'
    },
    [ObjectNames.squareAdjustableStairCorner]: {
        fileUrl: '/models/handrails-fitting-square.glb'
    },
    [ObjectNames.squareAdjustableStairCornerRotatable]: {
        fileUrl: '/models/handrails-fitting-square.glb'
    },
    [ObjectNames.squareFreeEnd]: {
        fileUrl: '/models/handrails-fitting-square.glb'
    },
    [ObjectNames.squareWallPlate]: {
        fileUrl: '/models/handrails-fitting-square.glb'
    },
    [ObjectNames.squareOblongWallPlate]: {
        fileUrl: '/models/handrails-fitting-square.glb'
    },
    // Posts
    [ObjectNames.postWooden]: {
        fileUrl: '/models/main.glb'
    },
    [ObjectNames.postThinIntermediate]: {
        fileUrl: '/models/main.glb'
    },
    [ObjectNames.postAluminium]: {
        fileUrl: '/models/posts-aluminium.glb'
    },
    [ObjectNames.postStainlessSteelRound]: {
        fileUrl: '/models/posts-stainless-steel.glb'
    },
    [ObjectNames.postStainlessSteelAngledRound]: {
        fileUrl: '/models/posts-stainless-steel.glb'
    },
    // Post Tops - Aluminium
    [ObjectNames.aluminiumTopIntermediate]: {
        fileUrl: '/models/posts-aluminium.glb'
    },
    [ObjectNames.aluminiumTopEnd]: {
        fileUrl: '/models/posts-aluminium.glb'
    },
    [ObjectNames.aluminiumTopCorner]: {
        fileUrl: '/models/posts-aluminium.glb'
    },
    [ObjectNames.aluminiumTopEndAngled]: {
        fileUrl: '/models/posts-aluminium.glb'
    },
    // Post Tops - Stainless Steel Flat
    [ObjectNames.stainlessSteelTopFlat4]: {
        fileUrl: '/models/posts-stainless-steel.glb'
    },
    [ObjectNames.stainlessSteelTopFlat1]: {
        fileUrl: '/models/posts-stainless-steel.glb'
    },
    [ObjectNames.stainlessSteelTopFlat3]: {
        fileUrl: '/models/posts-stainless-steel.glb'
    },
    [ObjectNames.stainlessSteelTopFlat2]: {
        fileUrl: '/models/posts-stainless-steel.glb'
    },
    [ObjectNames.stainlessSteelTopFlat7]: {
        fileUrl: '/models/posts-stainless-steel.glb'
    },
    [ObjectNames.stainlessSteelTopFlat6]: {
        fileUrl: '/models/posts-stainless-steel.glb'
    },
    [ObjectNames.stainlessSteelTopFlat5]: {
        fileUrl: '/models/posts-stainless-steel.glb'
    },
    // Post Tops - Stainless Steel Round
    [ObjectNames.stainlessSteelTopRound1]: {
        fileUrl: '/models/posts-stainless-steel.glb'
    },
    [ObjectNames.stainlessSteelTopRound2]: {
        fileUrl: '/models/posts-stainless-steel.glb'
    },
    [ObjectNames.stainlessSteelTopRound3]: {
        fileUrl: '/models/posts-stainless-steel.glb'
    },
    [ObjectNames.stainlessSteelTopRound4]: {
        fileUrl: '/models/posts-stainless-steel.glb'
    },
    [ObjectNames.stainlessSteelTopRound5]: {
        fileUrl: '/models/posts-stainless-steel.glb'
    },
    [ObjectNames.stainlessSteelTopRound6]: {
        fileUrl: '/models/posts-stainless-steel.glb'
    },
    [ObjectNames.stainlessSteelTopRound7]: {
        fileUrl: '/models/posts-stainless-steel.glb'
    },
    // Additional Posts
    [ObjectNames.postStainlessSteelRoundPlain]: {
        fileUrl: '/models/posts-stainless-steel.glb'
    },
    [ObjectNames.postStainlessSteelAngledRoundPlain]: {
        fileUrl: '/models/posts-stainless-steel.glb'
    },
    // Grommets and Hardware (no fileUrl needed for these)
    [ObjectNames.grommetLarge]: {
        fileUrl: '/models/main.glb'
    },
    [ObjectNames.grommetSmallBlack]: {
        fileUrl: '/models/main.glb'
    },
    [ObjectNames.grommetSmallSatin]: {
        fileUrl: '/models/main.glb'
    },
    [ObjectNames.grommetLargeBlack]: {
        fileUrl: '/models/main.glb'
    },
    [ObjectNames.grommetLargeAngledBlack]: {
        fileUrl: '/models/main.glb'
    },
    [ObjectNames.grommetStairAngledBlack]: {
        fileUrl: '/models/main.glb'
    },
    [ObjectNames.grommetStairAngledSatin]: {
        fileUrl: '/models/main.glb'
    }
};
export const getObjectInfo = (objectName)=>{
    const object = Objects[objectName];
    if (!object) {
        throw new Error(`Can not retrieve object info for object ${objectName}! It does not exist in the Objects map. Please add it to the Objects map.`);
    }
    return object;
};

//# sourceMappingURL=objects.js.map